/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Memory_UpdatedInputs */

const en_mk_mock_memory_updated = /** @type {(inputs: Mk_Mock_Memory_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated today`)
};

const id_mk_mock_memory_updated = /** @type {(inputs: Mk_Mock_Memory_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diperbarui hari ini`)
};

/**
* | output |
* | --- |
* | "Updated today" |
*
* @param {Mk_Mock_Memory_UpdatedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_memory_updated = /** @type {((inputs?: Mk_Mock_Memory_UpdatedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Memory_UpdatedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_memory_updated(inputs)
	return en_mk_mock_memory_updated(inputs)
});